module.exports = __webpack_public_path__ + "src/img/xiala.edf5b3f7.svg";